import axios from "axios";
import React, { useEffect, useState } from "react";
import * as Constants from '../../../constants/urls';
import { useCookies } from "react-cookie";
import LocationListFetch from "../LocationList/LocationListFetch";
import ProductRow from "../product/ProductRow";
import ShortcutsModal from "../Modal/ShortcutsModal";
import EndLocationModal from "../Modal/EndLocationModal";
import SuccessModal from "../Modal/SuccessModal";
import AnbargardaniStepOneSetting from "../Setting/AnbargardaniStepOneSetting";
import SettingsLinearBlackImage from '../../../assets/images/settings_solid_black.png';
import YesNoModal from "../../Modal/YesNoModal";
import AnbarGardaniForm from "../forms/AnbarGardaniForm";
import Operator from "../Labels/Operator";
import OkModal from "../../Modal/OkModal";
import Loading from "../../Loading/Loading";

const Steps = (props) => {

    const [location, setLocation] = useState(undefined);
    const [anbargardaniId, setanbargardaniId] = useState(4);
    const [selectLocation, setSelectLocation] = useState(undefined);
    const [search, setSearch] = useState(undefined);
    const [products, setProducts] = useState(undefined);
    const [endLocationModal, setEndLocationModal] = useState(false)
    const [closeWithButton, setCloseWithButton] = useState(false)
    const [settingMenu, setSettingMenu] = useState(false)
    const [closeWithLocation, setCloseWithLocation] = useState(false)
    const [shortcutModal, setShortcutModal] = useState(false)
    const [shortcutProps, setShortcutProps] = useState(undefined)
    const [successModal, setSuccessModal] = useState(false)
    const [closeWithAnbar, setCloseWithAnbar] = useState(false)
    const [anbargardaniList, setanbargardaniList] = useState(undefined)
    const [anbargardani, setanbargardani] = useState(true)
    const [anbargardaniTitle, setanbargardaniTitle] = useState("1404")
    const [stock, setStock] = useState(undefined);
    const [validate, setValidate] = useState(false)
    const [loading, setLoading] = useState(false);

    const [cookies, setCookie, removeCookie] = useCookies();
    const step = props.step;

    const p2e = s => s.replace(/[۰-۹]/g, d => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d))
    const a2e = s => s.replace(/[٠-٩]/g, d => '٠١٢٣٤٥٦٧٨٩'.indexOf(d))

    function getLocationStep() {
        const url = Constants.apiUrl + "/api/ag/locationStep/" + step + "/" + anbargardaniId;
        axios.get(url, {
            headers: {
                'Authorization': 'Bearer ' + cookies.user_server_token,
            }
        }).then((r) => {
            setLocation(r.data);
        }).catch((e) => {

        });
    }

    const changeStockHandler = (e) => {
        // if(e.target.value>=0 || e.target.value<=9)
        let newStock = a2e(p2e(e.target.value)) ;
        let packId = e.target.attributes.packId.value;

        if (stock != []) {
            const newState = stock.map(obj => {
                if (obj.packId == packId) {
                    return { ...obj, stock: newStock };
                }
                return obj;
            });
            setStock(newState);
        }
    }

    function getProducts(location) {
        setLoading(true);

        const url = Constants.apiUrl + "/api/ag/productStep";
        axios.post(url, {
            location: location,
            anbargardaniId: anbargardaniId,
            step: step
        }, {
            headers: {
                'Authorization': 'Bearer ' + cookies.user_server_token,
            }
        }).then((r) => {
            setLoading(false);

            setProducts(r.data);
            let stockObject = [];

            r.data.map((item, index) => {
                let newStockObject = { packId: item.id, productId: item.product_id, oldStock: item.stock, count: item.count, stock: "" }
                stockObject.push(newStockObject);

            })
            setStock(stockObject);

        }).catch((e) => {
            setLoading(false);

        });
    }

    const clearSelectLocation = () => {
        setProducts(undefined)
        setStock(undefined)

        setSelectLocation(undefined);
        setCloseWithButton(false)
        setCloseWithLocation(false)
    }
    const searchHandler = async (e) => {
        console.log("e.target.value", e.target.value);
        if (e.target.value === "") {
            setSearch(undefined);
            return;
        }
        var input = e.target.value.toString();

        const results = location.filter(post => {
            var loc = post.location.toString();
            return loc.toLowerCase().includes(input.toLowerCase())
        })

        if (results.length == 0)
            setSearch([]);
        else
            setSearch(results);
    }
    const clickLocation = (e) => {
        setSelectLocation(e.target.value);
        getProducts(e.target.value);
    }
    const openShortcutModal = (e) => {

        let productId = e.target.attributes.productId.value;
        let productUrl = e.target.attributes.productUrl.value;
        setShortcutProps({ id: productId, url: productUrl });
        setShortcutModal(true);
    }

    const stockValidation=()=>{
        let valid=false;
        stock.map(obj => {
            if (obj.stock == "" || obj.stock == null) { 
                valid= true;
            }
        }); 
        return valid
    }

    const submitThisLocation = () => {
        setEndLocationModal(false) 
        if(stockValidation()==true)
        setValidate(true);
         else
         closeThisLocation();
    }

    const closeThisLocation = () => {
        setLoading(true);

        const url = Constants.apiUrl + "/api/ag/closeLocation";
        axios.post(url, {
            anbargardaniId: anbargardaniId,
            location: selectLocation,
            packs: stock,
            step: step
        }, {
            headers: {
                'Authorization': 'Bearer ' + cookies.user_server_token,
            }
        }).then((r) => {
            setEndLocationModal(false);
            setSuccessModal(true);
            setLoading(false);

        }).catch((e) => {
            console.error(e);
            setLoading(false);

        });
    }

    const closeSuccessModal = () => {
        setSelectLocation(undefined);
        setProducts(undefined);
        setStock(undefined);
        getLocationStep();
        setSuccessModal(false);
    }
    const exit = () => {
        window.location.href = "/admin/anbarGardani"
    }

    function getAnbargardani() {
        setLoading(true);

        const url = Constants.apiUrl + "/api/ag/getAnbargardaniList";
        axios.get(url, {
            headers: {
                'Authorization': 'Bearer ' + cookies.user_server_token,
            }
        }).then((r) => {
            setLoading(false);

            setanbargardaniList(r.data);
        }).catch((e) => {
            setLoading(false);

   if(e.response.status==403)
            {
                window.location="403";
            }
        });
    }

    const anbargardaniHandle = (e) => {
        setanbargardaniId(e.target.value);
        setanbargardaniTitle(e.target.selectedOptions[0].innerText);
    }
    const anbargardaniSelectHandle = (e) => {
        if (anbargardaniId != 0) {
            setanbargardani(true);
            getLocationStep();

        }
    }

    const cleanAnbargardani = (e) => {
        setanbargardani(false);
        setCloseWithAnbar(false)
        setanbargardaniId("");
        setanbargardaniTitle("");
        setStock(undefined);
        setProducts(undefined)

    }

    useEffect(() => {
        getAnbargardani();

        if (anbargardaniId != 0) 
        getLocationStep();

        window.history.pushState(null, document.title, window.location.href);
        window.addEventListener('popstate', function (event) {
            window.history.pushState(null, document.title, window.location.href);
        })
        window.onbeforeunload = () => {
            return false;
        };
    }, [])

    useEffect(() => {

        window.history.pushState(null, document.title, window.location.href);
    window.addEventListener('popstate', function (event) {
        window.history.pushState(null, document.title, window.location.href);
    })

    window.onbeforeunload = () => {
        return false;
    };
})

    return (



        <>
            {!anbargardani ?
                <>

                    {closeWithButton ? <YesNoModal massage={"آیا از خروج اطمینان دارید ؟"} yes={exit} no={() => { setCloseWithButton(false) }} /> : ""}

                    <div className="container-fluid py-3 bg-primary text-white">
                        <div className="container">
                            <div className="text-right" >
                                <div style={{ position: "relative" }}>
                                    <img src={SettingsLinearBlackImage} style={{ cursor: "pointer", width: '30px', height: "30px" }} onClick={() => { setSettingMenu(!settingMenu) }} />
                                    {settingMenu && <AnbargardaniStepOneSetting exit={() => { setCloseWithButton(true); setSettingMenu(false) }} />}
                                </div>
                            </div>

                            {<AnbarGardaniForm anbargardani={anbargardaniList} selectAnbargardani={anbargardaniHandle} applyAnbargardani={anbargardaniSelectHandle} />}

                        </div>

                    </div>
                </>

                : products == undefined ?
                    <>
                        {closeWithButton ? <YesNoModal massage={"آیا از خروج اطمینان دارید ؟"} yes={exit} no={() => { setCloseWithButton(false) }} /> : ""}
                        {closeWithAnbar ? <YesNoModal massage={"آیا از تغییر انبارگردانی اطمینان دارید ؟"} yes={cleanAnbargardani} no={() => { setCloseWithAnbar(false) }} /> : ""}

                        <div className="container-fluid py-3 bg-primary text-white">
                            <div className="container">
                                <div className="text-right" >
                                    <div style={{ position: "relative" }}>
                                        <img src={SettingsLinearBlackImage} style={{ cursor: "pointer", width: '30px', height: "30px" }} onClick={() => { setSettingMenu(!settingMenu) }} />
                                        {settingMenu && <AnbargardaniStepOneSetting anbargardani={() => { setCloseWithAnbar(true); setSettingMenu(false) }} exit={() => {exit() }} />}
                                    </div>
                                </div>

                                <div className="my-2 text-right " >
                                    <label >جستجوی لوکیشن</label>
                                    <input type="text" className="form-control text-center" onChange={searchHandler} placeholder="جستجوی لوکیشن" />
                                </div>
                            </div>

                        </div>
                        <hr />
                        <div className="container">
                            <div className="text-center ">
                                <strong className="text-muted">برای انجام انبارگردانی {anbargardaniTitle} مرحله {step + 1} روی لوکیشن کلیک کنید</strong>
                            </div>

                            {location != undefined && location != [] && <LocationListFetch location={search != undefined ? search : location} click={clickLocation} />}
                        </div>
                    </>
                    :
                    <>
            {loading ? <div style={{position:"absolute",top:0,zIndex:10}}><Loading /></div> : ""}
            {closeWithButton ? <YesNoModal massage={"آیا از خروج اطمینان دارید ؟ تمام داده ها پاک میشود"} yes={exit} no={() => { setCloseWithButton(false) }} /> : ""}
                        {closeWithLocation ? <YesNoModal massage={"آیا از تغییر لوکیشن اطمینان دارید ؟ تمام داده ها پاک میشود"} yes={clearSelectLocation} no={() => { setCloseWithLocation(false) }} /> : ""}
                        {closeWithAnbar ? <YesNoModal massage={"آیا از تغییر انبارگردانی اطمینان دارید ؟ تمام داده ها پاک میشود"} yes={cleanAnbargardani} no={() => { setCloseWithAnbar(false) }} /> : ""}
                        {validate ? <OkModal headerTitle={"اخطار"} btnTitle={"تایید"} ok={()=>{setValidate(false)}} message={" .... پر کردن همه ی فیلد ها الزامی است"}/> : ""}

                        {shortcutModal ? <ShortcutsModal props={shortcutProps} close={() => { setShortcutModal(false) }} /> : ""}
                        {endLocationModal ? <EndLocationModal apply={submitThisLocation} close={() => { setEndLocationModal(false) }} /> : ""}
                        {successModal ? <SuccessModal apply={closeSuccessModal} /> : ""}

                        <div className="text-center bg-danger pb-4 pt-2">
                            <div className="text-right container" >
                                <div style={{ position: "relative" }}>
                                    <img src={SettingsLinearBlackImage} style={{ cursor: "pointer", width: '30px', height: "30px" }} onClick={() => { setSettingMenu(!settingMenu) }} />
                                    {settingMenu && <AnbargardaniStepOneSetting anbargardani={() => { setCloseWithAnbar(true); setSettingMenu(false) }} location={() => { setCloseWithLocation(true); setSettingMenu(false) }} exit={() => { setCloseWithButton(true); setSettingMenu(false) }} />}
                                </div>
                            </div>
                            <hr />
                            <strong className="text-white">انبارگردانی {anbargardaniTitle} مرحله {step + 1}  لوکیشن {selectLocation}</strong>

                        </div>
                    
                        {
                             products.map((item, index) => {
                                return (
                                    <div className="container my-4" style={{ borderRadius: "5px", border: "1px solid rgb(219, 219, 219)", minHeight: "120px" }}>

                                        <ProductRow openShortcut={openShortcutModal} image={item.product.prodID} name={item.product.prodName_fa} label={item.label} count={item.count} prodStock={stock} packId={item.id} productId={item.product_id} productUrl={item.product.url} changeStock={changeStockHandler} />
                                        {props.step==2 &&   <Operator stock={item.stock} stockOne={item.anbargardani_item[0].new_stock} stockTwo={item.anbargardani_item[1].new_stock} operatorOne={item.anbargardani_item[0].operator.name} operatorTwo={item.anbargardani_item[1].operator.name}/>}

                                    </div>
                                )
                            })
                        }


                        {location != "" ?

                            <div className="mt-4">
                                <button className="btn btn-block btn-danger" disabled={loading} onClick={() => { setEndLocationModal(true) }}>
                                    ثبت این لوکیشن
                                </button>
                            </div>
                            : ""}
                    </>
            }
        </>


    )
}
export default Steps;
